import { Module } from 'vuex'
import { blankModels } from '../editor-model/constants'
import State from './types'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '../types'

export const state: State = {
  error: false,
  modelSearchResults: blankModels,
  isShowingProductModels: false,
  preloaded: false,
  recentlySearchedPcns: [],
  categoryOpen: {},
  productClassOpen: {},
  manufacturingSeriesOpen: {},
  productOpen: {},
  treeCategories: [],
  term: '',
}
const namespaced = true

export const modelFinder: Module<State, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
}
